import React from "react";
import {DecimalCell} from "./workspace/DecimalCell";

export const StepHeader = ({ n, title, subtitle, testId }) => (
  <div className="flex items-start gap-2 mb-2" data-testid={testId}>
    <span className="inline-flex items-center justify-center w-6 h-6 bg-ink text-brass-500 text-[11px] font-black rounded-sm shrink-0">{n}</span>
    <div><div className="text-sm font-black tracking-tight">{title}</div>{subtitle && <div className="text-[10px] text-muted-foreground">{subtitle}</div>}</div>
  </div>
);

export const Rel = ({ v }) => {
  const cls = { GREEN: "bg-ok-100 text-ok-800 border-ok-300", YELLOW: "bg-warn-100 text-warn-800 border-warn-300", RED: "bg-risk-100 text-risk-800 border-risk-300" }[v] || "bg-muted";
  const label = { GREEN: "Affidabile", YELLOW: "Da verificare", RED: "Bloccato" }[v] || v;
  return <span className={`px-1.5 py-0.5 border rounded-sm text-[10px] font-bold uppercase ${cls}`}>{label}</span>;
};

export const Num = ({ v, d = 2 }) => <span className="font-mono">{v == null || Number.isNaN(Number(v)) ? "—" : Number(v).toFixed(d)}</span>;
export const Eur = ({ v }) => <span className="font-mono">{v == null ? "—" : `€ ${Number(v).toFixed(2)}`}</span>;

export const NumInput = ({ value, onChange, testId, placeholder, step = "0.1", className = "" }) => <div className={className}><DecimalCell value={value} onCommit={onChange} testId={testId} placeholder={placeholder} integer={String(step)==='1'} decimals={String(step)==='1'?0:Math.max(2,(String(step).split('.')[1]||'').length)}/></div>;

export const Select = ({ value, onChange, options, testId, className = "" }) => (
  <select value={value ?? ""} onChange={(e) => onChange(e.target.value === "" ? null : e.target.value)} data-testid={testId}
    className={`h-7 border border-input rounded-sm px-1.5 text-[11px] bg-white focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring ${className}`}>
    {options.map((o) => <option key={String(o.value)} value={o.value ?? ""}>{o.label}</option>)}
  </select>
);

export const short = (code) => (code || "").split(".").slice(-1)[0];
